/**
 * Shared version numbering utilities.
 * Used by VersionModal and Toolbar (auto-layout backup).
 */

export function incrementSubVersion(version) {
  const parts = (version || '1.0').split('.');
  const major = Number.parseInt(parts[0], 10) || 1;
  const minor = (Number.parseInt(parts[1], 10) || 0) + 1;
  return `${major}.${minor}`;
}

export function incrementMajorVersion(version) {
  const parts = (version || '1.0').split('.');
  const major = (Number.parseInt(parts[0], 10) || 1) + 1;
  return `${major}.0`;
}
